//
import { mapActions, mapState } from 'vuex'
import { RBtnAction, RForm, RTable } from '@/components/reusable_components/next'

//
import StockAdjustModel from '@/models/Warehouse/WhStockAdjustToList'

//
import filters from './filters'
import headers from './headers'

//
import TranslatorService from '@/services/translator'

//
export default {
    name: 'stock-adjust-list',
    components: {
        RBtnAction,
        RForm,
        RTable,
    },
    computed: {

        //
        ...mapState('SnackbarModalModule', [
            'responseConfirm',
        ]),

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        authorizeProps() {
            return {
                fields: [
                    {
                        name: 'confirm_description',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario'
                        },
                    }
                ],
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        rejectProps() {
            return {
                fields: [
                    {
                        name: 'confirm_description',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario'
                        },
                    }
                ],
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: StockAdjustModel,
                filters,
                headers,
            }
        },
    },
    data() {
        return {
            dialog: {
                authorize: false,
                reject: false,
            },
            selected: null,
        }
    },
    methods: {

        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setItemsTopBar: 'setAppToolbarItems',
        }),

        //
        ...mapActions('SnackbarModalModule', [
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         * { function_description }
         */
        authorize() {
            return this.toWait(true).then(this.toAuthorize).then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  error   The error
         * @return     {<type>}  { description_of_the_return_value }
         */
        error(error) {
            return this.setErrorSnackbar(TranslatorService(StockAdjustModel, error.response.data))
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        refresh() {
            return this.$refs.table.refresh()
        },

        /**
         * { function_description }
         */
        reject() {
            return this.toWait(true).then(this.toReject).then(this.toWait)
        },

        /**
         * Resets the object.
         */
        reset() {
            this.dialog.authorize = false
            this.dialog.reject = false
        },

        /**
         * @description
         * { function_description }
         *
         * @param   {<type>}    event   The event
         */
        submitAuthorize(event) {
            this.dialog.authorize = true
            this.selected = event.item
        },

        /**
         * { function_description }
         */
        submitCreate() {
            this.$router.push({ name: 'stock-adjust-create' })
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitConfirm() {
            return this.dialog.authorize ? this.authorize() : this.reject()
        },

        /**
         * @description
         * { function_description }
         *
         * @param   {<type>}    event   The event
         */
        submitReject(event) {
            this.dialog.reject = true
            this.selected = event.item
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  event   The event
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'stock-adjust-update',
                params: { id: event.item.id },
            })
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        successAuthorize() {
            return this.setSuccessSnackbar('Ajuste de stock autorizado exitosamente.')
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        successReject() {
            return this.setSuccessSnackbar('Ajuste de stock rechazado exitosamente.')
        },

        /**
         * Returns an authorize representation of the object.
         *
         * @return     {<type>}  Authorize representation of the object.
         */
        toAuthorize(model) {
            return model
                .authorize()
                .attach(model.toAuthorize())
                .then(this.successAuthorize)
                .then(this.refresh)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * Returns a reject representation of the object.
         *
         * @return     {<type>}  Reject representation of the object.
         */
        toReject(model) {
            return model
                .reject()
                .attach(model.toReject())
                .then(this.successReject)
                .then(this.refresh)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         */
        toWait(value = false) {
            return this.dialog.authorize ? this.$refs.authorize.setWait(value) : this.$refs.reject.setWait(value)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Ajustes de stock')
        this.setItemsTopBar({
            items: [
                {
                    action: this.submitCreate,
                    color: 'accent',
                    icon: 'add_circle',
                    text: 'crear ajuste de stock',
                    tip: 'Crear nuevo ajuste de stock',
                    can: 'CREATE_STOCK_ADJUST',
                },
            ],
        })
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_STOCK_ADJUST')) ctx.$router.push('/')
        })
    },
}
